import { render } from "./PrListPage.vue?vue&type=template&id=4643a8dc&scoped=true"
import script from "./PrListPage.vue?vue&type=script&lang=js"
export * from "./PrListPage.vue?vue&type=script&lang=js"

import "./PrListPage.vue?vue&type=style&index=0&id=4643a8dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4643a8dc"]])

export default __exports__